import { IconProps } from '../../modules/icons/IconProps';
export function ThermometerState2(props: IconProps) {
    return (
        <svg
            {...props}
            width="80"
            height="354"
            viewBox="0 0 80 354"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40 0C51.0457 0 60 8.95431 60 20V279.353C71.9557 286.269 80 299.195 80 314C80 336.091 62.0914 354 40 354C17.9086 354 0 336.091 0 314C0 299.195 8.04427 286.269 20 279.353V20C20 8.95431 28.9543 0 40 0Z"
                fill="#F5F5F5"
            />
            <path
                d="M40.3936 215.866C48.6359 213.165 56 215.999 56 215.999V281.744C67.8533 287.635 76 299.866 76 314C75.9999 333.882 59.8822 350 40 350C20.1178 350 4.00008 333.882 4 314C4 299.866 12.1467 287.635 24 281.744V215.999C24.0296 216.01 31.3807 218.828 39.6064 216.132L40.3936 215.866Z"
                fill="#B0E2C4"
            />
        </svg>
    );
}
